import ky, { isTimeoutError, isHTTPError } from "@otto-ec/global-resources/ky";
import { createLogger } from "utils/logging";
import type { FetchRetryArgs } from "./fetch.ts";

export async function kyFetch(args: FetchRetryArgs): Promise<Response> {
	const {
		url,
		namespace,
		timeout,
		retryOptions: { limit },
		fetchOptions,
	} = args;

	const logger = createLogger(namespace, "fetch-retry");

	const kyInstance = ky.extend({
		hooks: {
			beforeError: [
				({ error }) => {
					if (isTimeoutError(error)) {
						logger.warn(`[fetch] Timeout fetch to ${url}`);
					}
					return error;
				},
			],
		},
	});

	try {
		return await kyInstance(url, {
			retry: { limit, retryOnTimeout: true },
			timeout: timeout ?? false,
			...fetchOptions,
		});
	} catch (error) {
		if (isHTTPError(error)) {
			return error.response;
		}
		throw error;
	}
}
